









import { Component, Vue } from 'vue-property-decorator';
import ContactMessage from '@/components/ContactMessage.vue';
import ImageLayout from '@/components/ImageLayout.vue';

import { ChangePasswordFailureReason, ChangePasswordErrorMessages } from '../ChangePasswordFailureReason';

@Component({
  components: {
    ContactMessage,
    ImageLayout
  }
})
export default class ChangePasswordError extends Vue {
  get errorMessage(): string {
    const param = this.$route.query.p;

    if (typeof param !== 'string') {
      return this.defaultMessage;
    }

    let decoded: string;
    try {
      decoded = atob(param);
    } catch {
      return this.defaultMessage;
    }

    if (!Object.values(ChangePasswordFailureReason).includes(decoded as ChangePasswordFailureReason)) {
      return this.defaultMessage;
    }

    const message = ChangePasswordErrorMessages[decoded as ChangePasswordFailureReason];
    return message !== undefined && message !== null ? message : this.defaultMessage;
  }

  private readonly defaultMessage =
    'An unexpected error occurred while changing your password.';
}
